module.exports = __webpack_public_path__ + "static/media/ball-pile.652b94f2.svg";